import { render, staticRenderFns } from "./SISEC.vue?vue&type=template&id=f4fc0a74&"
import script from "./SISEC.vue?vue&type=script&lang=js&"
export * from "./SISEC.vue?vue&type=script&lang=js&"
import style0 from "./SISEC.vue?vue&type=style&index=0&id=f4fc0a74&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports